// extracted by mini-css-extract-plugin
export default {"header":"index_header_qdmt0","user":"index_user_EYc0B"};